import { gql, useMutation } from '@apollo/client';

const REPORT_BUG_MUTATION = gql`
  mutation reportBug($input: ReportBugInput!) {
    reportBug(input: $input) {
      success
      error
      taskUrl
    }
  }
`;

export const useReportBug = () => {
  const [reportBug, { data }] = useMutation(REPORT_BUG_MUTATION);

  return {
    reportBug,
    data,
  };
};
